"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveProgressExtensionDefinition = void 0;
const WidgetExtensionPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPlugin");
const WidgetExtensionPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPluginDefinition");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const configs_1 = require("../../../../configs/configs");
const InchcapeSelectorEvents_1 = require("../../Enum/InchcapeSelectorEvents");
class SaveProgressExtension extends WidgetExtensionPlugin_1.default {
    initialize(widget) {
        return Promise.resolve().then(() => {
            this.widget = widget;
            this.widget.getEventContainer()
                .on(WidgetEvents_1.WidgetEvents.STEP_READY, this.registerRestartEvents.bind(this));
        });
    }
    registerRestartEvents() {
        const actionElements = this.widget.getContainer().querySelectorAll(`[data-px-action="${configs_1.configs.actions.saveProgress}"]`);
        for (let i = 0, element; element = actionElements[i]; ++i) {
            element.addEventListener("click", this.saveProgress.bind(this));
        }
    }
    saveProgress() {
        this.widget.getEventContainer().emit(InchcapeSelectorEvents_1.InchcapeSelectorEvents.SAVE_PROGRESS, this.widget.getState().getAllCloned());
    }
}
exports.default = SaveProgressExtension;
exports.SaveProgressExtensionDefinition = new WidgetExtensionPluginDefinition_1.default({
    id: "save_progress",
    class: SaveProgressExtension
});
